import { FormSectionHandler } from '../entity.handler';
import { CompanyGroupResponse, CompanyGroupUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, MemoField } from '../utils';

export type EmailTemplateType = 'user_invite' | 'user_reset' | 'forgot_password';

interface EditorValues {
    template?: IdName;
    subject?: string;
    body?: string;
}

export class EmailTemplateSectionHandler implements FormSectionHandler<CompanyGroupResponse, EditorValues> {

    type = 'form';
    icon = 'envelope-open-text';
    bulk = false;

    title = this.translate(`${this.emailType.toUpperCase()}.TITLE`);
    description = this.translate(`${this.emailType.toUpperCase()}.DESC`);

    defaults = {
        user_invite: {
            template: { id: '00000000-0000-0000-0000-000000000000', name: this.translate('DEFAULT_TEMPLATE_NAME') },
            subject: this.translate('USER_INVITE.SUBJECT'),
            body: this.translate('USER_INVITE.BODY'),
        },
        forgot_password: {
            template: { id: '00000000-0000-0000-0000-000000000000', name: this.translate('DEFAULT_TEMPLATE_NAME') },
            subject: this.translate('FORGOT_PASSWORD.SUBJECT'),
            body: this.translate('FORGOT_PASSWORD.BODY'),
        },
        user_reset: {
            template: { id: '00000000-0000-0000-0000-000000000000', name: this.translate('DEFAULT_TEMPLATE_NAME') },
            subject: this.translate('USER_RESET.SUBJECT'),
            body: this.translate('USER_RESET.BODY'),
        },
    };

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public emailType: EmailTemplateType
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.COMPANYGROUP.EMAIL_CUSTOMIZATION.${key}`, values);
    }

    applyUpdate(entity: CompanyGroupResponse, payload: CompanyGroupUpdateRequest): Promise<CompanyGroupResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateCompanyGroup(entity.id, payload), { _navigation: 'companygroup' });
    }

    async mapEntityToEditor(entity: CompanyGroupResponse): Promise<EditorValues> {
        const def = this.defaults[this.emailType];
        if (entity.email.templates[this.emailType]) {
            const item = entity.email.templates[this.emailType];
            return {
                template: item.template || def.template,
                subject: item.subject || def.subject,
                body: item.body || def.body,
            };
        } else {
            return { ...this.defaults[this.emailType] };
        }
    }

    async mapEditorToEntity(entity: CompanyGroupUpdateRequest, values: EditorValues): Promise<CompanyGroupUpdateRequest> {
        entity.email = entity.email || {
            templates: {},
        },
        entity.email.templates[this.emailType] = values;
        return entity;
    }

    async getFields(entity: CompanyGroupResponse): Promise<FormBuilderField[]> {

        const fields = [
            // ComboField('template', this.translate('FIELDS.PARENT'), true, values, IdNameComboValueHandlers), TODO: add once templates are done
            TextField('subject', this.translate('FIELDS.SUBJECT'), true, 1, 1024),
            MemoField('body', this.translate('FIELDS.BODY'), true, 1, 4096),
        ];

        return EntityUtils.prepareBulk(!entity, [], fields);
    }

}
